export const colorActive = '#203D57';
export const colorActiveHover = '#203D575E';
export const colorInactive = '#21252aff';
export const colorActiveBoard = '#718A955E';
export const zoomButton = (active = false, extra = {}) => (Object.assign({ width: 40, height: 40, padding: 4, borderRadius: 10, background: active ? colorActive : colorInactive, color: '#fff', cursor: 'pointer', pointerEvents: 'auto', userSelect: 'none' }, extra));
export const tileButton = (active = false, extra = {}) => (Object.assign({ minWidth: 40, height: 40, padding: '8px 12px', borderRadius: 10, border: active ? `1px solid ${colorActiveBoard}` : `1px solid ${colorInactive}`, background: active ? colorActive : colorInactive, color: '#fff', cursor: 'pointer', pointerEvents: 'auto', userSelect: 'none' }, extra));
export const panelSurface = (extra = {}) => (Object.assign({ background: '#181a1bb6', borderRadius: 14, padding: 6, 
    // boxShadow: '0 2px 4px rgba(0, 0, 0, 0.12)',
    backdropFilter: 'blur(2px)', pointerEvents: 'none', userSelect: 'none' }, extra));
export const dividerStyle = {
    width: 1,
    height: 24,
    background: 'rgba(255, 255, 255, 0.08)',
    pointerEvents: 'none',
    userSelect: 'none',
};
